const getModuleState = state => state.app;

export const getError = state => getModuleState(state).error;

export const isLoading = state => getModuleState(state).loading;

export const getGroupPosts = state => getModuleState(state).groupPosts;

export const getPosts = groupId => state => getModuleState(state).groupPosts[groupId];
